module.exports = __webpack_public_path__ + "static/portrait-main-2c88b5c7ed862e8eab465865c1d5ce5f.png";